import { styled } from '@zoopla-eng/zds-components/themes';

export const NewHomesBody = styled('p', {
    fontGroup: 'ladle',
    color: '$textTitle',
    fontWeight: '$regular'
});
